import styled from 'styled-components'
import { Box } from '../components/box'
import { Text } from '../components/text'
import { Subtitle } from '../components/title'

const StyledSkill = styled(Box)`
    align-items: flex-start;
    gap: 0;

    h2 {
        margin: 0;
    }

    @media print {
        break-inside: avoid-page;
        page-break-inside: avoid;
    }
`

const Skill = ({ title, summary, description }) => <StyledSkill>
    <Subtitle bold>{ title }</Subtitle>
    <Text color="main" bold>{ summary }</Text>
    <Text>{ description }</Text>
</StyledSkill>

export const Skills = ({ skills }) => skills.map(item => <Skill
    title={ item.title }
    summary={ item.summary }
    description={ item.description }
/>)
